import { Component, OnInit } from '@angular/core';
import { TestScoreResponse } from '../../../models/account/test-score/testScoreResponse';
import { CompleteProfileService } from '../../../services/account/complete-profile.service';
import { ActivatedRoute } from '@angular/router';
import { HighSchoolGradesResponse } from '../../../models/account/grades/gradesResponse';
import { CourseWorkResponse } from '../../../models/account/coursework/courseWorkResponse';
import { Activity } from '../../../models/account/extra-curricular/activity/activityResponse';
import { PageResponse } from '../../../models/institute/randomInstituteResponse';
import { ActivityDetails } from '../../../models/account/extra-curricular/extraCurricularRequest';
import { CommonModule } from '@angular/common';
import { BoardsResponse } from '../../../models/board/boardResponse';
import { AdditionalInformationRightSectionComponent } from "../additional-information-right-section/additional-information-right-section.component";
import { AdditionalInformation } from '../../../models/enums/additionalInformation';
import { ViewProfileComponent } from '../../../student-portal/view-profile/view-profile.component';

@Component({
  selector: 'app-profile-section',
  standalone: true,
  imports: [CommonModule, AdditionalInformationRightSectionComponent, ViewProfileComponent],
  templateUrl: './profile-section.component.html',
  styleUrl: './profile-section.component.scss'
})
export class ProfileSectionComponent implements OnInit {
  studentId: string = '';
  testScore: TestScoreResponse | null | undefined;
  grades: HighSchoolGradesResponse | null | undefined;
  courseWork: CourseWorkResponse | null | undefined;
  activities: Activity[] | null | undefined;
  extraCurricularActivityResponse: PageResponse<ActivityDetails> | null | undefined;
  boards: BoardsResponse[] = [];
  selectedBoardName: string | null = null;
  boardIdFromCourseWork: number | null = null;

  infotype=AdditionalInformation;

  constructor(
    private completeProfileService: CompleteProfileService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
      this.studentId = this.route.snapshot.paramMap.get('id') || '';
      this.getTestScore();
      this.getGrades();
      this.loadBoards();
      this.getActivities();
    }

      getActivities() {
      this.completeProfileService.getActivities().subscribe({
        next: (response) => {
          this.activities = (response as any)?.result ?? response;
          this.completeProfileService.getExtraCurricular(this.studentId).subscribe({
            next: (result) => {
              this.extraCurricularActivityResponse = (result as any)?.result ?? result;
            }
          });
        }
      });
    }

      getCourseWork() {
      this.completeProfileService.getCourseWork(this.studentId).subscribe({
        next: (response: any) => {
          const data = response?.result ?? response;
          this.courseWork = data;
          this.boardIdFromCourseWork = data?.boardId ?? null;
          this.findAndSetBoardNameFromCourseWork(data?.boardId ?? undefined);
        },
        error: (err) => console.warn("Error loading CourseWork:", err),
      });
    }

      loadBoards() {
        this.completeProfileService.getBoards().subscribe({
          next: (response) => {
            this.boards = response.result;
            this.boards = [...this.boards, {
              id: -1,
              name: 'Other'
            }];
            this.getCourseWork();
          },
          error: (error) => {
            console.warn('Error in loading Boards');
          }
        });
      }

      findAndSetBoardNameFromCourseWork(boardId: number | undefined) { // Added function to find board name
        if (!boardId) {
          console.warn('Board ID from Coursework is missing.');
          this.selectedBoardName = 'Board ID Missing in Coursework';
          return;
        }

        const foundBoard = this.boards.find(board => board.id === boardId);


        if (foundBoard) {
          this.selectedBoardName = foundBoard.name;
        } else {
          console.warn(`Board with ID ${boardId} from Coursework not found in loaded boards.`);
          this.selectedBoardName = 'Board Name Not Found (in Boards List)';
        }
      }

      getGrades() {
      this.completeProfileService.getGrades(this.studentId).subscribe({
        next: (response: any) => {
          this.grades = response?.result ?? response;
        },
        error: (err) => console.warn("Error loading Grades:", err),
      });
    }

      getTestScore() {
      this.completeProfileService.getTestScore(this.studentId).subscribe({
        next: (response: any) => {
          this.testScore = response?.result ?? response;
        },
        error: (err) => console.warn("Error loading TestScore:", err),
      });
    }

      getActivityNameById(activityId: number): string | undefined {
        const activity = this.activities?.find(activity => activity.id === activityId);
        return activity ? activity.name : undefined;
      }


}
